import Screen from "../lib/Screen";

import * as PIXI from "pixi.js";

import ServiceLocator from "../ServiceLocator";
import Button from "../lib/Button";
import { screen_type } from "../state/GameState";
import ShopRow, { shop_row_type } from "./shop/ShopRow";
import ShopItem, { shop_item_state, shop_item_type } from "./shop/ShopItem";
import Settings from "./Settings";
import TutorialPopup from "./popup/TutorialPopup";
import Utils from "../Utils";
import Session from "../Session";
import GSAvatarLoader from "../lib/GSAvatarLoader";


export default class ShopScreen extends Screen
{
    // #region Attributes //

    // private:

    private _coinBalance: PIXI.Text = null;
    private _boardsTabTitle: PIXI.Sprite = null;
    private _boardsTabExclamationIcon: PIXI.Sprite = null;
    private _dartsTabTitle: PIXI.Sprite = null;
    private _dartsTabExclamationIcon: PIXI.Sprite = null;

    private _boardsTab: PIXI.Container = null;
    private _dartsTab: PIXI.Container = null;

    private _boardsRow: ShopRow = null;
    private _dartsRow: ShopRow = null;

    private _settings: Settings = null;

    // #endregion //


    // #region Methods //

    // public:

    public constructor()
    {
        super();
    }

    public onEnter(): void
    {
        super.onEnter();

        let layers: any = { bg: new PIXI.Container(), list: new PIXI.Container(), top: new PIXI.Container() };
        this._root.addChild( layers.bg, layers.list, layers.top );

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.shop_background.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        layers.bg.addChild( bg );

        let hudBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_user_hud_base.texture);
        hudBase.anchor.set( 0.5 );
        hudBase.scale.set( 0.7 );
        hudBase.position.set( 168 + 40 + 20, 72 );
        this._root.addChild( hudBase );
        //
        let xpBar: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_xp_bar.texture);
        xpBar.position.set( -hudBase.texture.width * 0.5 + 1, -hudBase.texture.height * 0.5 + 38 );
        hudBase.addChild( xpBar );
        //
        let xpBarMask: PIXI.Graphics = new PIXI.Graphics();
        xpBarMask.position.copyFrom( xpBar.position );
        xpBarMask.beginFill( 0xff3300 );
        xpBarMask.drawRect( 0, 0, xpBar.width, xpBar.height );
        xpBarMask.endFill();
        const kXpToNextLevel: number = Utils.findXpToNextLevel( ServiceLocator.saved.data.level );
        xpBarMask.scale.x = !Utils.isPlayerMaxLevel() ? Math.min( ServiceLocator.saved.data.xp / kXpToNextLevel, 1 ) : 1;
        hudBase.addChild( xpBarMask );
        xpBar.mask = xpBarMask;
        //
        let levelBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_level_base.texture);
        levelBase.anchor.set( 0.5 );
        levelBase.position.set( 117, 11 );
        hudBase.addChild( levelBase );
        //
        let levelValue: PIXI.Text = new PIXI.Text( ServiceLocator.saved.data.level.toString(), { fontSize: 50, fontFamily: "college_tm_regular", fill: 0x192f62, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        levelValue.anchor.set( 0.5 );
        levelValue.y = 2;
        levelBase.addChild( levelValue );
        //
        let xpValue: PIXI.Text = new PIXI.Text( !Utils.isPlayerMaxLevel() ? ServiceLocator.saved.data.xp.toString() + "/" + kXpToNextLevel.toString() : "MAX LEVEL", { fontSize: 34, fontFamily: "college_tm_regular", fill: 0x000000, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        xpValue.anchor.set( 0.5 );
        xpValue.position.set( 5, 20 );
        hudBase.addChild( xpValue );
        //
        let profileAvatar: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.avatar_you.texture );
        profileAvatar.scale.set( 87/profileAvatar.texture.width );
        profileAvatar.anchor.set( 0.5 );
        GSAvatarLoader.i.load( 
            Session.i.profile ? Session.i.profile.avatar.src : "avatar_you", 
            ( texture: PIXI.Texture ) => {
                try 
                {
                    profileAvatar.texture = texture;
                    profileAvatar.scale.set( 87/profileAvatar.texture.width );
                }
                catch( ex ) {}
                } );
        profileAvatar.position.set( -109, -9 );
        hudBase.addChild( profileAvatar );
        //
        let profileBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_avatar_base.texture );
        profileBase.anchor.set( 0.5 );
        profileBase.position.copyFrom( profileAvatar.position );
        hudBase.addChild( profileBase );
        //
        let profileTitle: PIXI.Text = new PIXI.Text( Session.i.profile ? Session.i.profile.username.prefix : "YOU", { 
            fontSize: 30, 
            fontFamily: "teko_regular", 
            fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 4,
            dropShadow: true,
            dropShadowAngle: 2,
            dropShadowColor: "#ffffff",
            dropShadowDistance: 2,
            lineJoin: "round"
        } );
        profileTitle.anchor.set( 0, 1 );
        profileTitle.position.set( -53, 1 );
        hudBase.addChild( profileTitle );

        let coinWrapper: PIXI.Container = new PIXI.Container();
        coinWrapper.scale.set( 0.8 );
        coinWrapper.position.set( 390 + 20, 44 + 16 + 20 );
        this._root.addChild( coinWrapper );
        //
        let coinIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
        coinIcon.anchor.set( 0.5 );
        coinWrapper.addChild( coinIcon );
        //
        this._coinBalance = new PIXI.Text( ServiceLocator.saved.data.coins.toString(), {
            fontSize: 60,
            fontFamily: "jaro_regular", 
            fill: 0xffffff
            /*fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 4,
            lineJoin: "round"*/
        } );
        this._coinBalance.anchor.set( 1, 0.5 );
        this._coinBalance.position.set( 542 - coinWrapper.x, 0 );
        coinWrapper.addChild( this._coinBalance );   
        Utils.fitTextToWidth( this._coinBalance, 116 );

        /*let headerDarkOverlay: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.career_header_dark_overlay.texture );
        headerDarkOverlay.anchor.x = 0.5;
        headerDarkOverlay.position.set( ServiceLocator.app.width * 0.5, -ServiceLocator.app.safeAreaMarginY );
        layers.top.addChild( headerDarkOverlay );*/

        this._dartsTab = new PIXI.Container();
        this._dartsTab.visible = true;
        layers.list.addChild( this._dartsTab );
        //
        let arrDartItem: Array<ShopItem> = [];
        for ( let i: number = 0; i < ServiceLocator.resources.game_config.data.darts.length; ++i )
        {
            let dartItem: ShopItem = new ShopItem();
            dartItem.type = shop_item_type.DART;
            if ( i == ServiceLocator.saved.data.selDartIndex )
            {
                dartItem.state = shop_item_state.SELECTED;
            }
            else if ( ServiceLocator.saved.data.ownedDarts.includes( i ) )
            {
                dartItem.state = shop_item_state.OWNED;
            }
            else if ( ServiceLocator.resources.game_config.data.darts[ i ].unlockLevel <= ServiceLocator.saved.data.level )
            {
                dartItem.state = shop_item_state.UNLOCKED;
            }
            else 
            {
                dartItem.state = shop_item_state.LOCKED;
            }
            dartItem.index = i;
            arrDartItem.push( dartItem );
        }
        //
        this._dartsRow = new ShopRow();
        this._dartsRow.type = shop_row_type.DART;
        this._dartsRow.items = arrDartItem;
        this._dartsRow.init();
        this._dartsRow.onEntered();
        this._dartsTab.addChild( this._dartsRow );
        this._dartsRow.onItemPurchased.add( this._onItem_Purchased, this );

        this._boardsTab = new PIXI.Container();
        this._boardsTab.visible = false;
        layers.list.addChild( this._boardsTab );
        //
        let arrBoardItem: Array<ShopItem> = [];
        for ( let i: number = 0; i < ServiceLocator.resources.game_config.data.boards.length; ++i )
        {
            let boardItem: ShopItem = new ShopItem();
            boardItem.type = shop_item_type.BOARD;
            if ( i == ServiceLocator.saved.data.selBoardIndex )
            {
                boardItem.state = shop_item_state.SELECTED;
            }
            else if ( ServiceLocator.saved.data.ownedBoards.includes( i ) )
            {
                boardItem.state = shop_item_state.OWNED;
            }
            else if ( ServiceLocator.resources.game_config.data.boards[ i ].unlockLevel <= ServiceLocator.saved.data.level )
            {
                boardItem.state = shop_item_state.UNLOCKED;
            }
            else
            {
                boardItem.state = shop_item_state.LOCKED;
            }
            boardItem.index = i;
            arrBoardItem.push( boardItem );
        }
        //
        this._boardsRow = new ShopRow();
        this._boardsRow.type = shop_row_type.BOARD;
        this._boardsRow.items = arrBoardItem;
        this._boardsRow.init();
        this._boardsTab.addChild( this._boardsRow );
        this._boardsRow.onItemPurchased.add( this._onItem_Purchased, this );

        let mask: PIXI.Graphics = new PIXI.Graphics();
        mask.y = 250;
        mask.beginFill( 0xffffff );
        mask.drawRect( 0, 0, ServiceLocator.app.width, ServiceLocator.app.safeAreaHeight - mask.y );
        mask.endFill();
        layers.list.mask = mask;
        this._root.addChild( mask );

        let backBtn: Button = new Button( { on: "button_back", pressed: "button_back_pressed" } );
        backBtn.anchor.set( 0.5 );
        backBtn.position.set( 48, 44 + 16 );
        layers.top.addChild( backBtn );
        backBtn.on( "pointertap", this._onBackBtn_Click, this );

        this._settings = new Settings();
        this._settings.init( false );
        this._settings.position.set( 592, 7 + 16 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );

        this._dartsTabTitle = new PIXI.Sprite( ServiceLocator.resources.shop_button_darts.texture );
        this._dartsTabTitle.anchor.set( 0.5 );
        this._dartsTabTitle.interactive = false;
        this._dartsTabTitle.buttonMode = false;
        this._dartsTabTitle.position.set( ServiceLocator.app.width * 0.5 - 140, 200 );
        layers.top.addChild( this._dartsTabTitle );
        this._dartsTabTitle.on( "pointertap", this._onDartsTabTitle_Click, this );
        //
        if ( ServiceLocator.saved.data.unlockedDarts.length > 0 )
        {
            this._dartsTabExclamationIcon = new PIXI.Sprite( ServiceLocator.resources.lobby_icon_exclamation.texture );
            this._dartsTabExclamationIcon.scale.set( 44 / this._dartsTabExclamationIcon.texture.width );
            this._dartsTabExclamationIcon.anchor.set( 0.5 );
            this._dartsTabExclamationIcon.position.set( this._dartsTabTitle.x + this._dartsTabTitle.width * 0.5, this._dartsTabTitle.y - this._dartsTabTitle.height * 0.5 );
            layers.top.addChild( this._dartsTabExclamationIcon );
        }

        this._boardsTabTitle = new PIXI.Sprite( ServiceLocator.resources.shop_button_boards_pressed.texture );
        this._boardsTabTitle.anchor.set( 0.5 );
        this._boardsTabTitle.interactive = true;
        this._boardsTabTitle.buttonMode = true;
        this._boardsTabTitle.position.set( ServiceLocator.app.width * 0.5 + 140, this._dartsTabTitle.y );
        layers.top.addChild( this._boardsTabTitle );
        this._boardsTabTitle.on( "pointertap", this._onBoardsTabTitle_Click, this );
        //
        if ( ServiceLocator.saved.data.unlockedBoards.length )
        {
            this._boardsTabExclamationIcon = new PIXI.Sprite( ServiceLocator.resources.lobby_icon_exclamation.texture );
            this._boardsTabExclamationIcon.scale.set( 44 / this._boardsTabExclamationIcon.texture.width );
            this._boardsTabExclamationIcon.anchor.set( 0.5 );
            this._boardsTabExclamationIcon.position.set( this._boardsTabTitle.x + this._boardsTabTitle.width * 0.5, this._dartsTabTitle.y - this._dartsTabTitle.height * 0.5 );
            layers.top.addChild( this._boardsTabExclamationIcon );
        }
    }

        private _onBackBtn_Click(): void
        {
            this._onCompleted.dispatch( screen_type.LOBBY );
        }

        private _onDartsTabTitle_Click(): void
        {
            ServiceLocator.audio.playSfx( "button_click" );
            
            this._boardsTabTitle.texture = ServiceLocator.resources.shop_button_boards_pressed.texture;
            this._boardsTabTitle.interactive = true;
            this._boardsTabTitle.buttonMode = true;

            this._dartsTabTitle.texture = ServiceLocator.resources.shop_button_darts.texture;
            this._dartsTabTitle.interactive = false;
            this._dartsTabTitle.buttonMode = false;

            this._boardsTab.visible = false;
            this._dartsTab.visible = true;

            this._boardsRow.resetScroll();
            this._dartsRow.resetScroll();
            this._dartsRow.onEntered();
        }

        private _onBoardsTabTitle_Click(): void
        {
            ServiceLocator.audio.playSfx( "button_click" );

            this._boardsTabTitle.texture = ServiceLocator.resources.shop_button_boards.texture;
            this._boardsTabTitle.interactive = false;
            this._boardsTabTitle.buttonMode = false;

            this._dartsTabTitle.texture = ServiceLocator.resources.shop_button_darts_pressed.texture;
            this._dartsTabTitle.interactive = true;
            this._dartsTabTitle.buttonMode = true;

            this._boardsTab.visible = true;
            this._dartsTab.visible = false;

            this._boardsRow.resetScroll();
            this._dartsRow.onLeft();
            this._dartsRow.resetScroll();
        }

        private _onItem_Purchased( selShopItem: ShopItem ): void
        {
            this._coinBalance.text = ServiceLocator.saved.data.coins.toString();

            if ( selShopItem.type == shop_item_type.DART )
            {
                if ( this._dartsTabExclamationIcon )
                {
                    this._dartsTabExclamationIcon.visible = ServiceLocator.saved.data.unlockedDarts.length > 0;
                }
            }
            else if ( selShopItem.type == shop_item_type.BOARD )
            {
                if ( this._boardsTabExclamationIcon )
                {
                    this._boardsTabExclamationIcon.visible = ServiceLocator.saved.data.unlockedBoards.length > 0;
                }
            }
        }

    public onLeave(): void
    {
        ServiceLocator.saved.data.unlockedDarts.splice( 0 );
        ServiceLocator.saved.data.unlockedBoards.splice( 0 );
        ServiceLocator.saved.save();

        this._boardsRow.end();
        this._boardsRow = null;

        this._dartsRow.end();
        this._dartsRow = null;

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }
    
    public onUpdate( dt: number ): void
    {
        if ( this._boardsTab.visible )
        {
            this._boardsRow.update( dt );
        }
        if ( this._dartsTab.visible )
        {
            this._dartsRow.update( dt );
        }
    }

    // #endregion //
}
